import { fromEvent } from "rxjs";
import { validate as uuidValidate } from "uuid";

import { IS_DEV, AFB_UNUSABLE_ELEMENTS } from "globals/constants";

export const transform = () => {
	try {
		// Hide various menu buttons (or even their parent container)
		const [ buttonMenuSave ] = document.getElementsByClassName("eo-vis-menu-save");
		buttonMenuSave.parentElement.style.display = "none";

		const [ buttonMenuZoomStandard ] = document.getElementsByClassName("eo-vis-menu-zoom-standard");
		buttonMenuZoomStandard.style.display = "none";

		const [ buttonMenuDataModelViewer ] = document.getElementsByClassName("eo-vis-menu-data-model-viewer");
		buttonMenuDataModelViewer.parentElement.style.display = "none";

		const [ buttonMenuExport ] = document.getElementsByClassName("eo-vis-export-menu");
		buttonMenuExport.parentElement.style.display = "none";

		const [ buttonMenuFormPreview ] = document.getElementsByClassName("eo-vis-menu-form-preview");
		buttonMenuFormPreview.parentElement.style.display = "none";

		const [ buttonMenuPublish ] = document.getElementsByClassName("eo-vis-menu-publish");
		buttonMenuPublish.parentElement.style.display = "none";


		// Move show grid and zoom fit buttons to the start, move validate and delete button to the end
		const [ menuBar ] = document.getElementsByClassName("eo-vis-menu-bar");

		const newMenu = document.createElement("div");
		newMenu.classList.add("eo-vis-menu");

		const [ buttonMenuShowGrid ] = document.getElementsByClassName("eo-vis-menu-show-grid");
		newMenu.appendChild(buttonMenuShowGrid);

		const [ buttonMenuZoomFit ] = document.getElementsByClassName("eo-vis-menu-zoom-fit");
		newMenu.appendChild(buttonMenuZoomFit);

		const [ buttonMenuValidate ] = document.getElementsByClassName("eo-vis-validate-menu");
		const [ buttonDelete ] = document.getElementsByClassName("eo-vis-menu-delete");

		const menuBarChild = menuBar.firstElementChild;
		menuBarChild.insertBefore(newMenu, menuBarChild.childNodes[0]);
		menuBarChild.append(buttonMenuValidate.parentElement);
		menuBarChild.append(buttonDelete.parentElement);

		//CRUX-3222 Remove unusable objects from the form builder
		const paletteElements = document.querySelectorAll("li.eo-vis-palette-group-item-node");
		paletteElements.forEach(element => {
			const elementName = element.querySelector("span").innerHTML;
			if (AFB_UNUSABLE_ELEMENTS.includes(elementName)) {
				element.style.display = "none";
			}
		});

		// CRUX-2961: Blank out fields with UUIDs so the user can fill them out with a meaningful identifier
		// Presentation only: empty-field rule is still enforced because those fields are still saved as UUIDs
		const formFields = document.querySelectorAll("div");
		const formField = fromEvent(formFields, "click");

		formField.subscribe(() => {
			const [ controlLabel ] = document.getElementsByClassName("eo-vis-attribute-control-input");
			const isUuid = uuidValidate(controlLabel?.value);

			if (isUuid) {
				controlLabel.value = "";
			}
		});
	} catch(error) {
		if (IS_DEV) {
			console.log(error);
		}
	}
};
